import { render, staticRenderFns } from "./taskDashboard.vue?vue&type=template&id=585b54c2&"
import script from "./taskDashboard.vue?vue&type=script&lang=js&"
export * from "./taskDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports